import React, { useEffect } from 'react'
import AriaModal from 'react-aria-modal'
import type { MouseEventHandler } from 'react'

interface DialogProps {
  actions?: any
  children: any
  className: string
  initialFocus?: string
  onCancel: MouseEventHandler<HTMLButtonElement>
  opened: boolean
  title: string
  id?: string
}

const Dialog = ({
  actions,
  children,
  className,
  initialFocus,
  onCancel,
  opened,
  title,
  id = 'modal-title',
}: DialogProps) => {
  // Manage custom class on html tag to prevent auto-scrolling that would
  // produce an unexpected animation due to default `scroll-behavior: smooth`
  // style
  useEffect(() => {
    if (opened) {
      document.documentElement.classList.add('no-scroll')
      return () => document.documentElement.classList.remove('no-scroll')
    }
  })

  if (!opened) {
    return null
  }

  const lastClassName = className.split(/\s+/).at(-1)

  return (
    <AriaModal
      dialogClass={className}
      getApplicationNode={getApplicationNode}
      includeDefaultStyles={false}
      initialFocus={initialFocus}
      focusDialog={initialFocus === undefined}
      onExit={onCancel}
      titleId={id}
      titleText={title}
      underlayClass='modal-overlay'
      scrollDisabled={true}
      data-testid={id}
      id='prout'
    >
      <div role='document' className={`${lastClassName}__wrapper`}>
        <button
          type='button'
          className={`${lastClassName}-close`}
          onClick={onCancel}
        >
          <span className={`${lastClassName}-close__text`}>Fermer</span>
        </button>
        <div className={`${lastClassName}__content`}>
          <h3 id='modal-title' className={`${lastClassName}-title`}>
            {title}
          </h3>
          <div id='js-modal-content' className='modal-content'>
            {children}
          </div>
          {actions}
        </div>
      </div>
    </AriaModal>
  )

  function getApplicationNode() {
    return document.getElementById('js-modal-page')
  }
}

export default Dialog
